import { put } from 'redux-saga/effects';
import { delay } from 'redux-saga';

export function* toast(action) {
  const { payload } = action;
  yield put({ type: 'TOAST_SHOW', payload });
  yield delay(payload.delay || 5000);
  yield put({ type: 'TOAST_HIDE' });
}



// WEBPACK FOOTER //
// ./src/view/common/Toast/saga.js